{
    "user-app-guide": {
        "title": "Οδηγός Εφαρμογής",
        "headers": {
            "title": "Τίτλος",
            "titleGR": "Ελληνικός Τίτλος",
            "content": "Περιεχόμενο",
            "contentGR": "Ελληνικό Περιεχόμενο",
            "subtitle": "Υπότιτλος",
            "subtitleGR": "Ελληνικός Υπότιτλος",
            "image": "Εικόνα",
            "status": "Κατάσταση",
            "actions": "Ενέργειες"
        },
        "DRAFT": "Προσωρινό",
        "PUBLISHED": "Δημοσιευμένο"
    },
    "Activity": "Ενεργό",
    "Νame": "Όνομα",
    "Created At": "Ημερομηνία Δημιουργίας",
    "Updated At": "Ημερομηνία Ενημέρωσης",

    "actions": "Ενέργειες",
    "global": {
        "yes": "Ναι",
        "no": "Όχι",
        "firstName": "Όνομα",
        "search-text": "Search Keyword",
        "query-methods": {
            "raw": "Ακατέργαστα",
            "sum": "Συγκεντρωτικά",
            "median": "Μέσες (mean)",
            "min": "Ελάχιστες",
            "max": "Μέγιστες",
            "mean": "Μέσες (average)"
        },
        "resolution-types": {
            "seconds": "Δευτερόλεπτα",
            "minutes": "Λεπτά",
            "hours": "Ώρες",
            "days": "Μέρες",
            "weeks": "Εβδομάδες",
            "months": "Μήνες",
            "years": "Χρόνια"
        },
        "records": "Εγγραφές",
        "record": "Εγγραφή",
        "no-data-available": "Δεν υπάρχουν διαθέσιμα δεδομένα!",
        "showing": "Εμφάνιση",
        "to": "έως",
        "of": "από",
        "more": "περισσότερα",
        "device-connected": "Συνδεδεμένη",
        "device-disconnected": "Αποσυνδεδεμένη",
        "devices-connected": "Συνδεδεμένες",
        "devices-disconnected": "Αποσυνδεδεμένες"
    },
    "device-groups": "Ομάδες Συσκευών",
    "headers": {
        "location-name": "Τοποθεσία",
        "tenant-name": "Ομάδα",
        "isEnabled": "Ενεργό",
        "macAddress": "Διεύθυνση Mac",
        "name": "Όνομα",
        "address": "Διεύθυνση",
        "device-type": "Τύπος",
        "type": "Τύπος",
        "description": "Περιγραφή",
        "AssignmentToken": "Assignment Token"
    },
    "Location": "Τοποθεσία",
    "Locations": "Τοποθεσίες",
    "tree": {},
    "name": "Όνομα",
    "isActive": "Κατάσταση",
    "repeat-Period": "Περίοδος Επανάληψης",
    "title": "Τίτλος",
    "started-Day": "Ημερομηνία Έναρξης",
    "status": "Κατάσταση",
    "description": "Περιγραφή",
    "startsWith": "Αρχίζει με",
    "contains": "Περιέχει",
    "type": "Τύπος",
    "action": "Ενέργεια",
    "notContains": "Δεν Περιέχει",
    "updatedAt": "Ανανεώθηκε",
    "createdAt": "Δημιουργήθηκε",
    "endsWith": "Τελειώνει με",
    "equals": "Ισο με",
    "notEquals": "Διαφορετικό από",
    "noFilter": "Χωρίς φίλτρο",
    "lt": "Μικρότερο από",
    "lte": "Μικρότερο από ή ίσο με",
    "gt": "Μεγαλύτερο από",
    "gte": "Μεγαλύτερο από ή ίσο με",
    "dateIs": "Ημερομηνία είναι",
    "dateIsNot": "Ημερομηνία δεν είναι",
    "dateBefore": "Ημερομηνία πριν",
    "dateAfter": "Ημερομηνία μετά",
    "custom": "Ειδική κατασκευή",
    "clear": "Καθαρισμός",
    "apply": "Εφαρμογή",
    "matchAll": "Ισοδύναμο με όλα",
    "matchAny": "Ισοδύναμο με τουλάχιστον ένα",
    "addRule": "Προσθήκη κανόνα",
    "removeRule": "Αφαίρεση κανόνα",
    "accept": "ΝΑΙ",
    "reject": "ΟΧΙ",
    "choose": "Επιλογή",
    "upload": "Ανεβάζω",
    "cancel": "Ακύρωση",
    "dayNames": ["Κυριακή", "Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο"],
    "dayNamesShort": ["Κυρ", "Δευ", "Τρι", "Τετ", "Πεμ", "Παρ", "Σαβ"],
    "dayNamesMin": ["Κυ", "Δε", "Τρ", "Τε", "Πε", "Πα", "Σα"],
    "monthNames": [
        "Ιανουάριος",
        "Φεβρουάριος",
        "Μάρτιος",
        "Απρίλιος",
        "Μάιος",
        "Ιούνιος",
        "Ιούλιος",
        "Αύγουστος",
        "Σεπτέμβριος",
        "Οκτώβριος",
        "Νοέμβριος",
        "Δεκέμβριος"
    ],
    "monthNamesShort": ["Ιαν", "Φεβ", "Μαρ", "Απρ", "Μαϊ", "Ιουν", "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"],
    "today": "Σήμερα",
    "weekHeader": "Wk",
    "firstDayOfWeek": 0,
    "showMonthAfterYear": false,
    "weak": "Αδύναμος",
    "medium": "Μεσαίος",
    "strong": "Δυνατός",
    "passwordPrompt": "Εισαγωγή κωδικού",
    "emptyFilterMessage": "Δεν υπάρχουν διαθέσιμες επιλογές",
    "emptyMessage": "Δεν βρέθηκαν αποτελέσματα",
    "Number": "Νούμερο",
    "Email": "Ηλεκτρονική Διεύθυνση",
    "Phone": "Τηλέφωνο",
    "Actions": "Ενέργειες",
    "Users": "Χρήστες",
    "errors": {
        "error": "Σφάλμα",
        "user": {
            "verificationFailed": "Η επαλήθευση του email απέτυχε. Παρακαλώ προσπαθήστε ξανά.",
            "subscription": "Σφάλμα Εγγραφής Χρήστη",
            "loadData": "Αδυναμία φόρτωσης δεδομένων χρήστη.",
            "updateFailed": "Η ενημέρωση χρήστη απέτυχε. Παρακαλώ προσπαθήστε ξανά.",
            "loginFailed": "Η σύνδεση απέτυχε.",
            "invalidCredentials": "Μη έγκυρα διαπιστευτήρια",
            "fetchFailed": "Αποτυχία λήψης πληροφοριών χρήστη.",
            "notFound": "Ο χρήστης δεν βρέθηκε.",
            "unauthorized": "Δεν έχετε εξουσιοδότηση για προβολή αυτών των πληροφοριών χρήστη.",
            "creationFailed": "Η δημιουργία χρήστη απέτυχε.",
            "deletionFailed": "Η διαγραφή χρήστη απέτυχε."
        },
        "roles": {
            "rolesLoadingFailed": "Αδυναμία φόρτωσης ρόλων",
            "invalidSelection": "Μη έγκυρη επιλογή ρόλου. Παρακαλώ επιλέξτε έναν έγκυρο ρόλο."
        },
        "token": {
            "expired": "Ο σύνδεσμος επαλήθευσης έχει λήξει.",
            "missing": "Δεν παρέχεται διακριτικό επαλήθευσης."
        },
        "network": {
            "timeout": "Σφάλμα Χρονικού Όριου Δικτύου",
            "disconnected": "Δεν είστε συνδεδεμένοι στο διαδίκτυο.",
            "serverError": "Παρουσιάστηκε σφάλμα κατά την επαλήθευση του λογαριασμού σας.",
            "loginAuthentication": "Δεν έχετε εξουσιοδότηση για πρόσβαση σε αυτήν την εφαρμογή."
        },
        "form": {
            "required": "Αυτό το πεδίο είναι υποχρεωτικό",
            "emailInvalid": "Το email δεν είναι έγκυρο",
            "maxLength": "Το πεδίο δεν μπορεί να υπερβαίνει τους {max} χαρακτήρες.",
            "validationError": "Σφάλμα Επικύρωσης",
            "checkInput": "Παρακαλώ ελέγξτε την είσοδό σας",
            "passwordMismatch": "Οι κωδικοί δεν ταιριάζουν"
        },
        "passwordReset": {
            "unableToReset": "Αδυναμία επαναφοράς κωδικού. Παρακαλώ προσπαθήστε ξανά αργότερα."
        },
        "registration": {
            "registrationFailed": "Η εγγραφή απέτυχε.",
            "tryAgainLater": "Παρακαλώ προσπαθήστε ξανά αργότερα."
        },
        "resetPassword": {
            "passwordChangeFailedMessage": "Η αλλαγή κωδικού απέτυχε",
            "newPasswordLabel": "Νέος Κωδικός",
            "confirmNewPasswordLabel": "Επιβεβαίωση Νέου Κωδικού",
            "changePasswordButton": "Αλλαγή Κωδικού"
        },
        "createPassword": {
            "passwordCreationFailedMessage": "Παρουσιάστηκε σφάλμα κατά τη δημιουργία του κωδικού σας. Παρακαλούμε δοκιμάστε ξανά."
        },
        "sidebar": {
            "unableToLoad": "Δεν ήταν δυνατή η φόρτωση των στοιχείων της πλευρικής μπάρας."
        }
    },
    "validation": {
        "required": "Αυτό το πεδίο είναι υποχρεωτικό",
        "email": "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email",
        "passwordStrength": "Ο κωδικός σας δεν πληροί τα απαιτούμενα κριτήρια ασφαλείας",
        "mismatch": "Οι κωδικοί δεν ταιριάζουν",
        "passwordStrengthValidation": {
            "upperCase": "Ο κωδικός πρόσβασης πρέπει να περιέχει κεφαλαίους χαρακτήρες",
            "lowerCase": "Ο κωδικός πρόσβασης πρέπει να περιέχει πεζούς χαρακτήρες",
            "number": "Ο κωδικός πρόσβασης πρέπει να περιέχει αριθμούς",
            "special": "Ο κωδικός πρόσβασης πρέπει να περιέχει ειδικούς χαρακτήρες",
            "minLength": "Ο κωδικός πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες."
        }
    },
    "success": {
        "emailVerified": "Το email επαληθεύτηκε επιτυχώς",
        "passwordResetRequested": "Σας έχουμε στείλει ένα email με οδηγίες για την επαναφορά του κωδικού.",
        "checkYourEmail": "Παρακαλώ ελέγξτε το email σας για τις οδηγίες επαναφοράς και ακολουθήστε τες για να ανακτήσετε την πρόσβαση.",
        "verificationSuccess": "Ο λογαριασμός σας έχει επαληθευτεί επιτυχώς.",
        "registrationSuccessful": "Η εγγραφή ήταν επιτυχής",
        "checkEmail": "Παρακαλώ ελέγξτε το email σας για να επαληθεύσετε τον λογαριασμό σας πριν συνδεθείτε.",
        "passwordChangeSuccess": "Επιτυχία",
        "passwordChangeSuccessMessage": "Ο κωδικός σας έχει αλλάξει επιτυχώς",
        "rolesLoadedSuccessfully": "Οι ρόλοι φορτώθηκαν επιτυχώς",
        "roleUpdated": "Ο ρόλος '{role}' ενημερώθηκε επιτυχώς.",
        "userCreated": "Ο χρήστης δημιουργήθηκε επιτυχώς.",
        "userUpdated": "Ο χρήστης ενημερώθηκε επιτυχώς.",
        "userDeleted": "Ο χρήστης διαγράφηκε επιτυχώς.",
        "tenantCreated": "Ο ενοικιαστής δημιουργήθηκε επιτυχώς.",
        "tenantUpdated": "Ο ενοικιαστής ενημερώθηκε επιτυχώς.",
        "tenantDeleted": "Ο ενοικιαστής διαγράφηκε επιτυχώς.",
        "userRemovedFromTenant": "Ο χρήστης αφαιρέθηκε από τον ενοικιαστή επιτυχώς.",
        "specificationCreated": "Η προδιαγραφή δημιουργήθηκε επιτυχώς.",
        "specificationUpdated": "Η προδιαγραφή ενημερώθηκε επιτυχώς.",
        "specificationDeleted": "Η προδιαγραφή διαγράφηκε επιτυχώς.",
        "specificationSpecCreated": "Η προδιαγραφή δημιουργήθηκε επιτυχώς.",
        "specificationSpecUpdated": "Η προδιαγραφή ενημερώθηκε επιτυχώς.",
        "specificationSpecDeleted": "Η προδιαγραφή διαγράφηκε επιτυχώς.",
        "locationCreated": "Η τοποθεσία δημιουργήθηκε επιτυχώς.",
        "locationUpdated": "Η τοποθεσία ενημερώθηκε επιτυχώς.",
        "locationDeleted": "Η τοποθεσία διαγράφηκε επιτυχώς.",
        "subLocationCreated": "Η υποτοποθεσία δημιουργήθηκε επιτυχώς.",
        "subLocationUpdated": " Η υποτοποθεσία ενημερώθηκε επιτυχώς.",
        "subLocationDeleted": "Η υποτοποθεσία διαγράφηκε επιτυχώς.",
        "subLocationExpanded": "Η υποτοποθεσία επεκτάθηκε",
        "subLocationCollapsed": "Η υποτοποθεσία έκλεισε",
        "gatewayCreated": "Η πύλη δημιουργήθηκε επιτυχώς.",
        "gatewayUpdated": "Η πύλη ενημερώθηκε επιτυχώς.",
        "gatewayDeleted": "Η πύλη διαγράφηκε επιτυχώς.",
        "deviceCreated": "Η συσκευή δημιουργήθηκε επιτυχώς.",
        "deviceUpdated": "Η συσκευή ενημερώθηκε επιτυχώς.",
        "deviceDeleted": "Η συσκευή διαγράφηκε επιτυχώς.",
        "passwordCreationSuccess": "Ο Κωδικός Δημιουργήθηκε Επιτυχώς",
        "passwordCreationSuccessMessage": "Ο κωδικός σας έχει δημιουργηθεί επιτυχώς.",
        "success": "Επιτυχία",
        "guideCreated": "Η δημοσίευση δημιουργήθηκε επιτυχώς.",
        "guideUpdated": "Η δημοσίευση ενημερώθηκε επιτυχώς.",
        "guideDeleted": "Η δημοσίευση διαγράφηκε επιτυχώς."
    },
    "warnings": {
        "warning": "Προειδοποίηση",
        "noMatchingTenant": "Δεν βρέθηκε αντίστοιχος ενοικιαστής. Παρακαλώ ελέγξτε την εισαγωγή σας.",
        "tenantsArrayEmpty": "Δεν υπάρχουν διαθέσιμοι ενοικιαστές. Παρακαλώ βεβαιωθείτε ότι οι ενοικιαστές έχουν ρυθμιστεί σωστά."
    },
    "login": {
        "title": "Σύνδεση",
        "hello": "Γεια σου,",
        "noAccount": "Δεν έχετε λογαριασμό;",
        "createToday": "Δημιουργήστε σήμερα!",
        "rememberMe": "Να με θυμάσαι",
        "forgotPassword": "Ξεχάσατε τον κωδικό;",
        "signIn": "Είσοδος",
        "tryAgainMessage": "η μπορείτε να δοκιμάσετε να συνδεθείτε ξανά."
    },
    "forgetPassword": {
        "title": "Ξεχάσατε τον κωδικό",
        "enterEmailToReset": "Εισάγετε το email σας για να επαναφέρετε τον κωδικό σας",
        "emailSentTitle": "Το Email Εστάλη Επιτυχώς!",
        "checkInbox": "Ελέγξτε τα εισερχόμενά σας για οδηγίες επαναφοράς κωδικού.",
        "checkSpam": "Εάν δεν λάβετε email, βεβαιωθείτε ότι ελέγξατε τον φάκελο ανεπιθύμητων μηνυμάτων.",
        "logInAccount": "Συνδεθείτε στον λογαριασμό σας",
        "newPasswordRequest": "Μπορείτε να ζητήσετε νέο σύνδεσμο επαναφοράς κωδικού σε:",
        "requestPasswordReset": "Επαναφορά Κωδικού",
        "emailAlreadySent": "Το email έχει ήδη σταλεί, ελέγξτε το inbox σας.",
        "emailSentConfirmation": "Ένα email επαναφοράς κωδικού έχει ήδη αποσταλεί στην ηλεκτρονική σας διεύθυνση.",
        "checkInboxReminder": "Βεβαιωθείτε ότι έχετε ελέγξει και τον φάκελο των ανεπιθύμητων μηνυμάτων (spam)."
    },
    "signup": {
        "title": "Εγγραφή",
        "haveAccount": "Έχετε λογαριασμό;",
        "firstName": "Όνομα",
        "firstNamePlaceholder": "Εισάγετε το όνομά σας",
        "lastName": "Επώνυμο",
        "lastNamePlaceholder": "Εισάγετε το επώνυμό σας",
        "confirmPassword": "Επιβεβαίωση Κωδικού",
        "confirmPasswordPlaceholder": "Επανεισάγετε τον κωδικό σας",
        "registerButton": "Εγγραφή"
    },
    "emailVerification": {
        "missingToken": "Λείπει Το Token",
        "resetLinkExpired": "Ο Σύνδεσμος Επαναφοράς Έληξε",
        "resetLinkExpiredRetry": "Παρακαλούμε ζητήστε έναν νέο σύνδεσμο επαναφοράς του κωδικού.",
        "goToLoginBtn": "Πήγαινε στη Σελίδα Σύνδεσης",
        "congratulations": "Συγχαρητήρια!",
        "navigateLogin": "Μπορείτε να μεταβείτε στη σελίδα σύνδεσης"
    },
    "resetPassword": {
        "resetLinkExpired": "Ο σύνδεσμος επαναφοράς έχει λήξει",
        "retryResetLink": "Εάν δεν λάβατε email, ελέγξτε τον φάκελο ανεπιθύμητης αλληλογραφίας ή δοκιμάστε να ζητήσετε έναν νέο σύνδεσμο επαναφοράς.",
        "doYouHaveAccount": "Έχετε λογαριασμό;",
        "loginToAccount": "Συνδεθείτε στον λογαριασμό σας!",
        "resetPassword": "Επαναφορά Κωδικού",
        "setNewPassword": "Παρακαλώ ορίστε έναν νέο κωδικό για τον λογαριασμό σας.",
        "passwordChangedSuccessfully": "Ο κωδικός άλλαξε επιτυχώς",
        "passwordChangedSuccess": "Ο κωδικός σας έχει αλλάξει επιτυχώς.",
        "loginWithNewPassword": "Μπορείτε τώρα να συνδεθείτε με τον νέο σας κωδικό.",
        "newPassword": "Νέος Κωδικός",
        "confirmNewPassword": "Επιβεβαίωση Νέου Κωδικού",
        "changePassword": "Αλλαγή Κωδικού"
    },
    "createPassword": {
        "createLinkExpired": "Ο σύνδεσμος δημιουργίας νέου κωδικού έχει λήξει",
        "retryCreateLink": "Εάν δεν λάβατε email, ελέγξτε τον φάκελο με τα ανεπιθύμητα μηνύματα ή δοκιμάστε να ζητήσετε έναν νέο σύνδεσμο για τη δημιουργία κωδικού.",
        "createNewPassword": "Δημιουργία Νέου Κωδικού",
        "pleaseCreateNewPassword": "Παρακαλώ δημιουργήστε έναν νέο κωδικό για τον λογαριασμό σας",
        "passwordSuccessfullyCreated": "Ο Κωδικός Δημιουργήθηκε Επιτυχώς",
        "passwordHasBeenSuccessfullyCreated": "Ο κωδικός σας έχει δημιουργηθεί επιτυχώς"
    },
    "setPassword": {},
    "commonAuth": {
        "back": "Πίσω",
        "emailLabel": "Ηλεκτρονική Διεύθυνση",
        "logIn": "Σύνδεση",
        "loading": "Φόρτωση",
        "logInAccount": "Συνδεθείτε στον λογαριασμό σας",
        "emailPlaceholder": "Εισάγετε το email σας",
        "passwordLabel": "Κωδικός",
        "passwordPlaceholder": "Εισάγετε τον κωδικό σας",
        "showPassword": "Εμφάνιση κωδικού",
        "hidePassword": "Απόκρυψη κωδικού",
        "unauthorizedAccess": "Δεν έχετε εξουσιοδότηση για πρόσβαση σε αυτήν την εφαρμογή.",
        "unauthorizedDetail": "Εάν πιστεύετε ότι πρόκειται για λάθος, επικοινωνήστε με τον διαχειριστή σας,",
        "cancel": "Ακύρωση"
    },
    "user": {
        "admin": "Διαχειριστής",
        "endUser": "Τελικός Χρήστης",
        "role": "Ρόλος",
        "activity": "Κατάσταση",
        "createUser": "Δημιουργία Χρήστη",
        "isActive": "Ενεργός",
        "save": "Αποθήκευση"
    },
    "sidebar": {
        "preferencesTitle": "Προτιμήσεις",
        "darkMode": "Σκοτεινή Λειτουργία",
        "header": {
            "subMenu": {
                "account": "Ο λογαριασμός μου",
                "logout": "Αποσύνδεση"
            }
        }
    },
    "default_sub_label_key": "Προεπιλεγμένο Υποστοιχείο",
    "home": {
        "title": "Αρχική",
        "test": "Αυτο ειναι το Home!"
    },
    "dashboard": {
        "title": "Ταμπλό Συσκευών "
    },
    "common": {
        "user": "Χρήστης"
    },
    "commonAction": {
        "goBack": "Επιστροφή",
        "retryLogin": "Δοκιμάστε ξανά"
    },
    "administrator": {
        "title": "Διαχείρηση"
    },
    "smartips-news": {
        "title": "Έξυπνες προτάσεις και Νέα"
    },
    "support": {
        "title": "Υποστήριξη",
        "search": "Αναζήτηση",
        "email-required": "Απαιτείται email",
        "email-valid": "Μη έγκυρη μορφή email",
        "connected": "Συνδεδεμένες",
        "details": "Λεπτομέρειες"
    },
    "support-page": {
        "title": "Σελίδα Υποστήριξης"
    },
    "explore": {
        "title": "Εξερεύνηση",
        "execute": "Εκτέλεση"
    },
    "admin": {
        "tabs": {
            "users": "Χρήστες",
            "tenants": "Πελάτες",
            "locations": "Τοπποθεσίες",
            "devices": "Συσκευές",
            "device-groups": "Ομάδες Συσκευών",
            "specifications": "Προδιαγραφές",
            "gateways": "Πύλες",
            "assets": "Στοιχεία"
        },
        "users": {
            "firstName": "Όνομα",
            "lastName": "Επώνυμο",
            "phone": "Τηλέφωνο",
            "email": "Ηλ. Διεύθυνση",
            "roles": "Ρόλοι",
            "active": "Ενεργός",
            "inactive": "Ανενεργός",
            "userId": "Id Χρήστη",
            "roleId": "Id Ρόλου",
            "sortBy": "Ταξινόμηση κατά",
            "update": "Ενημέρωση",
            "reset": "Επαναφορά",
            "change": "Άλλαγή κωδικού"
        },
        "device-groups": {
            "title": "Ομάδες Συσκευών",
            "group": "Ομάδα",
            "create-group": "Δημιουργία Ομάδας",
            "update-group": "Επεξεργασία Ομάδας",
            "view-group": "Προβολή Ομάδας",
            "delete-group": "Διαγραφή Ομάδας"
        },
        "tenants": {
            "confirmDelete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε τον ενοικιαστή: ",
            "tenantDialogHeader": {
                "update": "Ενημέρωση Ενοικιαστή",
                "create": "Δημιουργία Ενοικιαστή",
                "view": "Προβολή Ενοικιαστή",
                "delete": "Διαγραφή Ενοικιαστή"
            }
        },

        "locations": {
            "form": {
                "adminUser": "Διαχειριστής Χρήστης",
                "baseUsers": "Βασικοί Χρήστες",
                "tenantName": "Όνομα Ενοικιαστή",
                "addBaseUser": "Προσθήκη βασικού χρήστη",
                "changeSiteManager": "Αλλαγή διαχειριστή ιστότοπου",
                "selectUser": "Επιλέξτε χρήστη",
                "address": "Διεύθυνση",
                "locationlng": "Γεωγραφικό Μήκος",
                "locationlat": "Γεωγραφικό πλάτος",
                "fieldIsRequired": "Το πεδίο είναι υποχρεωτικό.",
                "description": "Περιγραφή",
                "confirmDelete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε την τοποθεσία: ",
                "location": "Τοποθεσία",
                "create-location": "Δημιουργία Τοποθεσίας",
                "update-location": "Επεξεργασία Τοποθεσίας",
                "view-location": "Προβολή Τοποθεσίας",
                "delete-location": "Διαγραφή Τοποθεσίας"
            }
        },
        "sublocations": {
            "form": {
                "confirmDelete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε την υποτοποθεσία: "
            }
        },
        "user": {
            "users": "Χρήστες",
            "selectRoles": "Επιλέξτε ρόλους",
            "selectRole": "Επιλέξτε ρόλο",
            "noRoles": "Δεν υπάρχουν διαθέσιμοι ρόλοι",
            "form": {
                "confirmDelete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε τον χρήστη: ",
                "fieldIsRequired": "Το πεδίο είναι υποχρεωτικό.",
                "token": "Διακριτικό",
                "tenant": "Ένοικος",
                "user": "Χρήστης",
                "selectUser": "Επιλέξτε χρήστη"
            },
            "addUser": "Προσθήκη Χρήστη",
            "editThisUser": "<b>Επεξεργαστείτε</b> αυτόν το Χρήστη",
            "deleteThisUser": "<b>Διαγράψτε</b> αυτόν το Χρήστη",
            "usersInOrder": "Ορίστε τους <b>Χρήστες</b> σε σειρά"
        },
        "userDialogHeaders": {
            "update": "Επεξεργασία Χρήστη",
            "create": "Δημιουργία Χρήστη",
            "view": "Προβολή Χρήστη",
            "delete": "Διαγραφή Χρήστη"
        }
    },
    "dateRangeSelector": {
        "customPeriod": "Προσαρμοσμένη Περίοδος:",
        "startDate": "Ημερομηνία Έναρξης",
        "endDate": "Ημερομηνία Λήξης",
        "today": "Σήμερα",
        "yesterday": "Χθες",
        "thisWeek": "Αυτήν την Εβδομάδα",
        "thisMonth": "Αυτόν το Μήνας",
        "last7Days": "Τελευταίες 7 Ημέρες",
        "last30Days": "Τελευταίες 30 Ημέρες",
        "lastWeek": "Προηγούμενη Εβδομάδα",
        "lastMonth": "Προηγούμενος Μήνας",
        "last3Months": "Τελευταίοι 3 Μήνες",
        "selectPeriodPlaceholder": "Επιλέξτε Περίοδο",
        "apply": "Εφαρμογή",
        "clear": "Καθαρισμός",
        "reset": "Επαναφορά",
        "dateFormat": "dd/MM/yyyy HH:mm",
        "validationErrorMessage": "Παρακαλώ εξασφαλίστε ότι όλα τα πεδία ημερομηνίας έχουν συμπληρωθεί σωστά.",
        "successMessage": "Η επιλογή του εύρους ημερομηνιών εφαρμόστηκε με επιτυχία.",
        "notifications": {
            "warning": "Προειδοποίηση",
            "success": "Επιτυχία"
        },
        "selectedDateRange": "Επιλεγμένο Χρονικό Διάστημα",
        "clearDates": "Καθαρισμός Ημερομηνιών"
    },
    "ac_enums": {
        "action": {
            "mode": "Λειτουργία",
            "airflow": "Ροή Αέρα",
            "temperature": "Θερμοκρασία"
        },
        "mode": {
            "off": "Κλειστό",
            "auto": "Αυτόματο",
            "cool": "Ψύξη",
            "heat": "Θέρμανση",
            "fanonly": "Ανεμιστήρας",
            "dry": "Αφύγρανση"
        },
        "airflow": {
            "weak": "Ασθενής",
            "medium": "Μέτρια",
            "strong": "Ισχυρή",
            "auto": "Αυτόματη"
        },
        "temperature": {
            "celsius": "Κελσίου",
            "fahrenheit": "Φαρενάιτ",
            "heatTemperature": "Θέρμανση",
            "coolTemperature": "Ψύξη"
        }
    },
    "devices": {
        "AreaSensor": "Αισθητήρες",
        "DoorWindowSensor": "Παγίδες",
        "Thermostat": "Θερμοστάτες",
        "Plug": "Πρίζες",
        "Lamp": "Λάμπες",
        "Relay": "Θερμοσίφωνες",
        "PowerMeter": "Μετρητές",
        "AC": "Κλιματιστικά",
        "plug": "Πρίζα",
        "bulb": "Λάμπα",
        "relay": "Ρελέ",
        "thermostat": "Θερμοστάτης",
        "device": " Συσκευή",
        "loading": "Εφαρμογή αλλαγών",
        "lastUpdated": "Τελευταία ενημέρωση",
        "gateways": "Πύλες",
        "totalRecords": "εγγραφές",
        "select": {
            "actuation-type": "Επιλέξτε τον τύπο της συσκευής",
            "device": "Επιλέξτε την συσκευή",
            "action": "Επιλέξτε ενέργεια",
            "variable": "Επιλέξτε μια μεταβλητή",
            "operator": "Επιλέξτε μια συνθήκη",
            "value": "Πρόσθεσε μια τιμή"
        },
        "success": {
            "modeUpdated": "Η λειτουργία ενημερώθηκε επιτυχώς.",
            "airflowUpdated": "Η ροή αέρα ενημερώθηκε επιτυχώς.",
            "temperatureUpdated": "Η θερμοκρασία ενημερώθηκε επιτυχώς.",
            "true": "{{deviceName}} ενεργοποιήθηκε με επιτυχία",
            "false": "{{deviceName}} απενεργοποιήθηκε με επιτυχία",
            "groupCreated": "Η ομάδα συσκευών δημιουργήθηκε με επιτυχία",
            "groupUpdated": "Η ομάδα συσκευών ενημερώθηκε με επιτυχία",
            "groupDeleted": "Η ομάδα συσκευών διαγράφηκε με επιτυχία"
        },
        "notifications": {
            "dataError": "Δεν υπάρχουν διαθέσιμα δεδομένα για τις ρυθμίσεις του AC.",
            "connectionError": "Σφάλμα κατά τη συνδρομή στα δεδομένα."
        },
        "actions": {
            "retry": "Προσπάθεια επανασύνδεσης. Προσπάθεια #{count}: επανάληψη σε {time} χιλιοστά του δευτερολέπτου.",
            "isActive": "Είναι ενεργό",
            "searchKeyword": "Αναζήτηση λέξης-κλειδί",
            "records": "Εγγραφές"
        },
        "error": {
            "invalidMode": "Η επιλεγμένη λειτουργία δεν είναι έγκυρη.",
            "invalidAirflow": "Η επιλεγμένη ροή αέρα δεν είναι έγκυρη.",
            "invalidTemperature": "Ο επιλεγμένος έλεγχος θερμοκρασίας δεν είναι έγκυρος.",
            "acModeError": "Αποτυχία αλλαγής μεθόδου",
            "airFlowError": "Αποτυχία αλλαγης ροή αέρα",
            "acTemperatureError": "Αποτυχία αλλαγής θερμοκρασίας",
            "dataError": {
                "summary": "Σφάλμα Δεδομένων",
                "detail": "Δεν υπάρχουν διαθέσιμα δεδομένα για τις ρυθμίσεις του AC."
            },
            "connectionError": "Σφάλμα σύνδεσης:",
            "subscriptionError": "Σφάλμα στη συνδρομή δεδομένων:",
            "error": "Σφάλμα",
            "serializationError": "Παρουσιάστηκε σφάλμα κατά την προετοιμασία των δεδομένων για αποστολή.",
            "true": "Αποτυχία ενεργοποίησης της {{deviceName}}",
            "false": "Αποτυχία απενεργοποίησης της {{deviceName}}",
            "loadError": "Αποτυχία φόρτωσης ομάδων συσκευών ή δεδομένων χρηστών"
        },
        "ariaLabels": {
            "airflowIntensitySlider": "Ρυθμιστής έντασης ροής αέρα",
            "heatingTemperatureSlider": "Ρυθμιστής θερμοκρασίας θέρμανσης",
            "coolingTemperatureSlider": "Ρυθμιστής θερμοκρασίας ψύξης"
        },
        "legends": {
            "airflowIntensity": "Ένταση Ροής Αέρα",
            "heatingTemperature": "Θερμοκρασία Θέρμανσης",
            "coolingTemperature": "Θερμοκρασία Ψύξης"
        },
        "statusLabel": "Κατάσταση",
        "status": {
            "connected": "Συνδεδεμένο",
            "disconnected": "Αποσυνδεδεμένο",
            "Home": {
                "success": "{{deviceName}} Λειτουργία Σπίτι",
                "error": "{{deviceName}}: Η ενημέρωση της λειτουργίας του απέτυχε"
            },
            "Away": {
                "success": "{{deviceName}} Λειτουργία Εκτός",
                "error": "{{deviceName}}¨Η ενημέρωση της λειτουργίας του απέτυχε"
            }
        },
        "hotwater": {
            "true": {
                "success": "Ζεστό Νερό ενεργοποιήθηκε",
                "error": "Η αλλαγή του Ζεστού Νερού απέτυχε"
            },
            "false": {
                "success": "Ζεστό Νερό έκλεισε",
                "error": "Η αλλαγή του Ζεστού Νερού απέτυχε"
            }
        },
        "temperature": {
            "success": "Η θερμοκρασία ενημερώθηκε με επιτυχία",
            "error": "Η ενημέρωση της θερμοκρασίας απέτυχε"
        },
        "connectionStatus": {
            "tryingToConnect": "Προσπάθεια σύνδεσης στη συσκευή...",
            "failedToConnect": "Αποτυχία σύνδεσης. Παρακαλώ δοκιμάστε ξανά.",
            "connected": "Η συσκευή συνδέθηκε.",
            "disconnected": "Η συσκευή αποσυνδέθηκε.",
            "retry": "Προσπάθεια επανασύνδεσης με τη συσκευή...",
            "retryFailed": "Αποτυχία επανασύνδεσης με τη συσκευή. Παρακαλώ δοκιμάστε ξανά.",
            "stableSubscriptionFailed": "Αποτυχία δημιουργίας σταθερής συνδρομής μετά από επαναλαμβανόμενες προσπάθειες.",
            "unknown": "Άγνωστη κατάσταση σύνδεσης."
        },
        "operations": {
            "deleteSelectedGateway": "Διαγραφή της επιλεγμένης πύλης",
            "editSelectedGateway": "Επεξεργασία της επιλεγμένης πύλης",
            "viewSelectedGatewayDetails": "Προβολή λεπτομερειών της επιλεγμένης πύλης",
            "changeSelectedGatewaySettings": "Αλλαγή ρυθμίσεων της επιλεγμένης πύλης",
            "unpairAllDevicesFromSelectedGateway": "Αποσύνδεση όλων των συσκευών από την επιλεγμένη πύλη",
            "pairNewDeviceWithSelectedGateway": "Σύζευξη νέας συσκευής με την επιλεγμένη πύλη",
            "pairingInProgress": "Η σύζευξη είναι σε εξέλιξη, παρακαλώ περιμένετε",
            "noRecordsFound": "Δεν βρέθηκαν εγγραφές",
            "operationFailed": "Η λειτουργία απέτυχε",
            "anErrorOccurred": "Παρουσιάστηκε σφάλμα",
            "deletion": {
                "processBegun": "Η διαδικασία διαγραφής έχει ξεκινήσει",
                "processStartedFor": "Η διαδικασία διαγραφής έχει ξεκινήσει για",
                "completed": "Η διαγραφή ολοκληρώθηκε",
                "noDevicesFoundFor": "Δεν βρέθηκαν συσκευές για διαγραφή για",
                "initiated": "Έναρξη διαγραφής",
                "initiatedFor": "Έναρξη διαγραφής για",
                "failedFor": "Η ζεύξη απέτυχε για",
                "failed": "Η διαγραφή απέτυχε",
                "noMacAddress": "Δεν βρέθηκε διεύθυνση MAC για τη συσκευή πύλης."
            },
            "pairing": {
                "processBegun": "Η διαδικασία ζεύξης έχει ξεκινήσει",
                "processStartedFor": "Η διαδικασία ζεύξης έχει ξεκινήσει για",
                "initiated": "Έναρξη ζεύξης",
                "initiatedFor": "Έναρξη ζεύξης για",
                "failedFor": "Η ζεύξη απέτυχε για",
                "completed": "Η ζεύξη ολοκληρώθηκε",
                "failed": "Η ζεύξη απέτυχε",
                "errorDuring": "Σφάλμα κατά τη διάρκεια της ζεύξης:",
                "invalidDataReceived": "Λήφθηκαν μη έγκυρα δεδομένα κατά τη σύζευξη.",
                "pairedDevices": "Συζευγμένες Συσκευές",
                "pairedDevicesHeader": "Συζευγμένες Συσκευές:",
                "noPairedDevicesFound": "Δεν βρέθηκαν συζευγμένες συσκευές"
            },
            "fetchDevices": {
                "failedFor": "Αποτυχία λήψης συσκευών για"
            },
            "confirmation": {
                "title": "Διαγραφή Συζευγμένων Συσκευών",
                "deleteAllPairedDevices": "<center> Είστε βέβαιοι ότι θέλετε να διαγράψετε όλες τις συζευγμένες συσκευές; <br> Αυτή η ενέργεια δεν μπορεί να αναιρεθεί. </center>",
                "rejectedTitle": "Η διαγραφή απορρίφθηκε",
                "rejectedMessage": "Ακυρώσατε τη διαγραφή των συνδεδεμένων συσκευών."
            },
            "actions": {
                "accept": "Αποδοχή",
                "reject": "Απόρριψη"
            }
        },
        "deviceGroups": {
            "selectLocation": "Επιλέξτε μια τοποθεσία για να δείτε τις διαθέσιμες ομάδες!",
            "selectedDevices": "Επιλεγμένες Συσκευές",
            "availableDevices": "Διαθέσιμες Συσκευές",
            "groupName": "Όνομα",
            "groupPlaceholderName": "εισάγετε το όνομα της ομάδας",
            "groupDescription": "Περιγραφή",
            "groupPlaceholderDescription": "εισάγετε την περιγραφή της ομάδας",
            "user": "Χρήστης",
            "groupPlaceholderUser": "επιλέξτε χρήστη για την ομάδα",
            "groupIcon": "Εικονίδιο",
            "groupPlaceholderIcon": "επιλέξτε εικονίδιο για την ομάδα",
            "confirmDelete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε την ομάδα συσκευών: ",
            "columns": {
                "id": "ID",
                "icon": "Εικονίδιο",
                "name": "Όνομα",
                "userEmail": "Χρήστης",
                "description": "Περιγραφή",
                "actions": "Ενέργειες",
                "createdAt": "Δημιουργήθηκε",
                "updatedAt": "Ενημερώθηκε"
            }
        },
        "ai": {
            "singlePhaseHeatPump": "Αντλία Θερμότητας Μονοφασική",
            "threePhaseHeatPump": "Αντλία Θερμότητας Τριφασική",
            "waterHeater": "Θερμοσίφωνας",
            "oven": "Φούρνος",
            "microwaveOven": "Φούρνος Μικροκυμάτων",
            "washingMachine": "Πλυντήριο",
            "dryer": "Στεγνωτήριο",
            "dishwasher": "Πλυντήριο Πιάτων",
            "fridge": "Ψυγείο",
            "toaster": "Φρυγανιέρα",
            "coffeeMachine": "Καφετιέρα"
        },
        "gateway": {
            "update": "Αναβάθμιση",
            "gatewayManagement": "Διαχείριση Πύλης",
            "macAddress": "Διεύθυνση Mac Address",
            "serialNumber": "Σειριακός Αριθμός",
            "enabled": "Ενεργοποιημένο",
            "yes": "Ναι",
            "no": "Όχι",
            "owner": "Ιδιοκτήτης",
            "created": "Δημιουργήθηκε",
            "lastUpdate": "Τελευταία Ενημέρωση",
            "availability": "Διαθεσιμότητα",
            "pairing": "Σύζευξη",
            "reset": "Επαναφορά",
            "sync": "Συγχρονισμός"
        },
        "measurement": {
            "labels": {
                "temperature": "Θερμοκρασία",
                "humidity": "Υγρασία",
                "luminance": "Φωτεινότητα",
                "status": "Κατάσταση",
                "time": "Ωρα",
                "last-movement": "Τελευτάια κίνηση",
                "low-battery": "Χαμηλή μπαταρία",
                "setpoint": "Setpoint",
                "mode": "Mode",
                "hot-water": "Ζεστό νερό",
                "energy": "Κατανάλωση",
                "power": "Ισχύς",
                "airflow": "Ένταση Ροής Αέρα",
                "heat-temp": "Θερμοκρασία Θέρμανσης",
                "cool-temp": "Θερμοκρασία Ψύξης",
                "brightness": "Φωτεινότητα",
                "color-temperature": "Χρωματική Θερμοκρασία",
                "color": "Χρώμα"
            },
            "values": {
                "open": "Ανοιχτο",
                "closed": "Κλειστο",
                "on": "Ανοιχτο",
                "off": "Κλειστο",
                "home": "Home",
                "away": "Away"
            }
        }
    },
    "units": {
        "celsius": "°C",
        "percent": "%"
    },
    "buttons": {
        "save": "Αποθήκευση",
        "cancel": "Ακύρωση",
        "delete": "Διαγραφή",
        "back": "Πίσω",
        "next": "Επόμενο",
        "aria": {
            "save": "Κουμπί αποθήκευσης",
            "cancel": "Κουμπί ακύρωσης",
            "delete": "Κουμπί διαγραφής",
            "back": "Κουμπί επιστροφής"
        },
        "synchronize": "Συγχρονισμός"
    },
    "lamp": {
        "change": "Άλλαξε το χρώμα",
        "brightness": "Άλλαξε την φωτεινότητα",
        "color-temp": "Άλλαξε την θερμοκρασια του χρώματος"
    },
    "trigger": "Ενεργοποίηση",
    "brightness": "Φωτεινότητα",
    "color": "Χρώμα",
    "color-temp": "Θερμοκρασία Χρώματος",
    "mode": "Λειτουργία",
    "airflow": "Ροή Αέρα",
    "temperature": "Θερμοκρασία",
    "pair": "Σύζευξη",
    "occupancy-mode": "Λειτουργία Κατοίκησης",
    "heat/setpoint/home": "Ρύθμιση Θερμοκρασίας (Σπίτι)",
    "heat/setpoint/away": "Ρύθμιση Θερμοκρασίας (Μακριά)",
    "hot-water/trigger/home": "Ενεργοποίηση Ζεστού Νερού (Σπίτι)",
    "hot-water/trigger/away": "Ενεργοποίηση Ζεστού Νερού (Μακριά)",
    "stepper": {
        "naming": "Όνομα",
        "actions": "Ενέργειες",
        "conditions": "Συνθήκες",
        "timings": "Χρόνος",
        "isActive": "Ενεργός",
        "sendNotification": "Ενεργοποίηση Ειδοποιήσεων",
        "sendEmail": "Αποστολή Εμαιλ",
        "icon": "Εικονίδιο",
        "add-actions": "Προσθήκη Ενέργειας",
        "add-conditions": "Προσθήκη  Συνθηκών",
        "add-conditions-group": "Προσθήκη ομάδας Συνθηκών",
        "logic": "Λογική",
        "operator": "Χειριστής",
        "minutes": "Λεπτά",
        "value": "Αξία",
        "startDate": "Ημερομηνία έναρξης",
        "endDate": "Ημερομηνία λήξης",
        "weekdays": "Καθημερινές",
        "time": "Ώρα",
        "everyNMinutes": "Κάθε Ν λεπτά"
    },
    "smart-tips": {
        "header": "Έξυπνες Συμβουλές και Νέα",
        "type": "Τύπος",
        "name": "Όνομα",
        "title": "Τίτλος",
        "message": "Μήνυμα",
        "starting-date": "Ημερομηνία Έναρξης",
        "time": "Ώρα",
        "repeat-period": "Περίοδος Επανάληψης",
        "end-date": "Ημερομηνία Λήξης",
        "smart-tip": "Έξυπνη συμβουλή",
        "news": "Νέα",
        "select-name": "Επιλέξτε όνομα",
        "select-title": "Επιλέξτε τίτλο",
        "select-message": "Επιλέξτε μήνυμα",
        "select-time": "Επιλέξτε ώρα",
        "once": "Μια φορά",
        "every-day": "Κάθε μέρα",
        "every-week": "Κάθε εβδομάδα",
        "every-month": "Κάθε μήνα",
        "fill-the-form": "Συμπληρώστε τα παρακάτω πεδία"
    },

    "fields": {
        "expiration": "Ημερομηνία Λήξης",
        "repeatPeriod": "Περίοδος Επανάληψης",
        "validationMessage": "Συμπληρώστε τα παρακάτω πεδία: ",
        "fill-the-form": "Συμπληρώστε τα παρακάτω πεδία",
        "Type": "Τύπος",
        "Name": "Όνομα",
        "Notification Title": "Τίτλος",
        "Notification Message": "Μήνυμα",
        "Start Date": "Ημερομηνία Έναρξης",
        "Time": "Ώρα",
        "repeat-period": "Περίοδος Επανάληψης",
        "end-date": "Ημερομηνία Λήξης"
    },
    "scenesNrules": {
        "delete": "Διαγραφή Σεναρίου",
        "confirmation": "Επιβεβαίωση",
        "cancel": "Ακύρωση",
        "actions": {
            "accept": "Αποδοχή",
            "reject": "Απόρριψη"
        }
    },

    "scenes": {
        "add-device": "Προσθήκη Συσκευής"
    },

    "weather_conditions": {
        "Clear": "Καθαρός ουρανός",
        "Clouds": "Συννεφιά",
        "Tornado": "Τυφώνας",
        "Ash": "Ηφαιστειακή τέφρα",
        "Dust": "Σκόνη",
        "Sand": "Άμμος",
        "Fog": "Ομίχλη",
        "Haze": "Αχλύς",
        "Smoke": "Καπνός",
        "Mist": "Καταχνιά",
        "Snow": "Χιόνι",
        "Rain": "Βροχή",
        "Drizzle": "Ψιλή βροχή",
        "Thunderstorm": "Καταιγίδα"
    },
    "general": {
        "thermostat-programm": "Πρόγραμμα Θερμοστάτη",
        "save": "Αποθήκευση",
        "reset-programm": "Επαναφορά Προγράμματος",
        "place": "χώρος",
        "device-disconnection": "Αποσύνδεση συσκευών",
        "device-disconnection-info": "Θα ενημερώνεσαι όταν αποσυνδέεται κάποια συσκευή από τις επιλεγμένες κατηγορίες.",
        "and": "και",
        "groups": "ΟΜΑΔΕΣ",
        "devices": "Συσκευές",
        "device-lower": "συσκευή",
        "devices-lower": "συσκευές",
        "all-movements": "Όλες οι κινήσεις",
        "start-here": "Ξεκίνα εδώ!",
        "learn-how": "Μάθε πως!",
        "see-more": "Δες περισσότερα",
        "other": "Άλλο",
        "water-added": "Η Λειτουργία ζεστού νερού ενεργοποιήθηκε",
        "water-removed": "Η Λειτουργία ζεστού νερού απενεργοποιήθηκε",
        "select-address": "Επιλογή Διεύθυνσης",
        "select-address-info": "Επίλεξε τη διεύθυνση που θα προστεθεί το Gateway.",
        "connection-failed": "Η σύνδεση απέτυχε",
        "something-went-wrong": "Ουπς! Κάτι πήγε στραβά.",
        "copy": "Αντιγραφή",
        "period": "Διάστημα",
        "schedule-updated": "Το πρόγραμμα ενημερώθηκε",
        "period-limit": "Έχετε φτάσει το όριο διαστημάτων",
        "thermostat-schedule": "Πρόγραμμα",
        "thermostat-schedule-info": "Όρισε τα διαστήματα μέσα στη διάρκεια της ημέρας που θα λειτουργεί ο θερμοστάτης, σύμφωνα με το πρόγραμμά σου. ",
        "thermostat-period-info": "Όρισε τη διάρκεια του κάθε διαστήματος ή/και χώρισέ το σε μικρότερα διαστήματα. ",
        "reset": "Επαναφορά",
        "time-scheduling": "Χρονοπρογραμματισμός",
        "replace-text": "Παρακάτω οι συσκευές που είναι διαθέσιμες για αντικατάσταση:",
        "replace": "Αντικατάσταση άλλης συσκευής",
        "confirm-delete-message": "Είσαι σίγουρος/η ότι θέλεις να διαγράψεις την συσκευή; Όλα τα σταστιστικά και το ιστορικό της συσκεύης θα διαγραφούν.",
        "confirm-reset-message": "Είσαι σίγουρος/η ότι θέλεις να αποσυνδέσεις την συσκευή;",
        "device-reseted": "Η συσκευή αποσυνδέθηκε",
        "device-deleted": "Η συσκευή διαγράφηκε",
        "edit-scene": "Επεξεργασία σεναρίου",
        "edit-rule": "Επεξεργασία κανόνα",
        "shortcut-text": "Πρόσθεσε εδώ συντομεύσεις για να έχεις άμεση πρόσβαση στις συσκευές και τα σενάρια που χρησιμοποιείς πιο συχνά.",
        "edit-evice": "Επεξεργασία συσκευής",
        "my-shortcuts": "ΟΙ ΣΥΝΤΟΜΕΥΣΕΙΣ ΜΟΥ",
        "minuteAgo": "λεπτό πριν",
        "minutesAgo": "λεπτά πριν",
        "hourAgo": "ώρα πριν",
        "hoursAgo": "ώρες πριν",
        "updates": "ΕΝΗΜΕΡΩΣΕΙΣ",
        "news-and-offers": "ΝΕΑ & ΠΡΟΣΦΟΡΕΣ",
        "notifications-title": "Οι Ειδοποιήσεις μου",
        "unexpected-error": "Σφάλμα",
        "unexpected-error-message": "Κάτι πήγε στραβά. Παρακαλούμε δοκιμάστε ξανά αργότερα.Αν το πρόβλημα παραμένει, επικοινωνήστε με την υποστήριξη πελατών.",
        "operating-history": "Ιστορικό Λειτουργίας",
        "movement-history": "Ιστορικό Κινήσεων",
        "under-construction": "Υπο Κατασκευή",
        "more": "Περισσότερα",
        "target-goal": " του στόχου κατανάλωσης",
        "restore": "Επαναφορά",
        "cancel": "Άκυρο",
        "exit": "Έξοδος",
        "exit-app": "Έξοδος από την Εφαρμογή",
        "exit-app-message": "Είστε σίγουροι ότι θέλετε να κλείσετε την εφαρμογή;",
        "select": "Επιλογή",
        "energy-consumption": "live κατανάλωση",
        "energy-instructions": "Δες απλές συμβουλές εξοικονόμησης ενέργειας!",
        "next": "Επόμενο",
        "confirm": "Επιβεβαίωση",
        "password": "Κωδικός",
        "welcome": "Καλώς ήρθες στο",
        "how-it-works": "Δες πώς δουλεύει",
        "success": "Επιτυχία",
        "continue": "ΣΥΝΕΧΕΙΑ",

        "device": "Συσκευή",
        "devices-capital": "ΣΥΣΚΕΥΕΣ",
        "congrats": "Συγχαρητήρια!",
        "close": "Κλείσιμο",
        "submit": "Υποβολή",
        "loading": "Loading...",
        "disconnected": "Αποσυνδεδεμένο",
        "disable": "Απενεργοποίηση",
        "enable": "Ενεργοποίηση",
        "choose": "Επίλεξε",
        "number": "Αριθμός",
        "year": "Έτος",
        "delete": "Διαγραφή",
        "new-invitation": "Νέα πρόσκληση",
        "send": "Αποστολή",
        "change": "Αλλαγή",
        "name": "Όνομα",
        "lastName": "Επώνυμο",
        "fail": "Αποτυχία σύνδεσης",
        "apply": "Εφαρμογή",
        "from": "από",
        "to": "εώς",
        "at": "στις"
    },

    "rules": {
        "at": "στις",
        "add-action": "+  Προσθήκη ενέργειας",
        "lum": "φωτ",
        "add-condition": "+  Προσθήκη συνθήκης",
        "info-txt": "Με τους κανόνες δεν χρειάζεται να ανησυχείς για τίποτα! Το Smarthink Θα εκτελεί αυτόματα τις ενέργειες που έχεις ορίσει.",
        "select-condition": "Επιλογή Συνθήκης",
        "time": "Χρονική στιγμή",
        "time-info": "Θέλω ο κανόνας να εκτελείται μία συγκεκριμένη ώρα.",
        "all-days": "Κάθε μέρα",
        "add-range": "Προσθήκη διαστήματος",
        "add-time": "Προσθήκη χρονικής στιγμής",
        "schedule": "ΔΙΑΣΤΗΜΑ ΗΜΕΡΑΣ",
        "processing-option": "Επεξεργασία κανόνα",
        "copy-option": "Δημιουργία αντιγράφου",
        "delete-option": "Διαγραφή κανόνα",
        "new": "Νέος κανόνας",
        "settings-rules": "ΡΥΘΜΙΣΕΙΣ ΚΑΝΟΝΑ",
        "time-schedule": "ΧΡΟΝΟΠΡΟΓΡΑΜΜΑΤΙΣΜΟΣ",
        "when": "Όταν",
        "when-text": "συμβεί οποιοδήποτε από τα παρακάτω:",
        "and-if": "και εφόσον",
        "and-if-text": "ισχύει οτιδήποτε από τα παρακάτω (προαιρετικό)",
        "then": "τότε",
        "then-text": "θα εκτελούνται οι παρακάτω ενέργειες:",
        "choose": "Διάλεξε πότε θα εκτελείται ο κανόνας:",
        "temperature": "Θερμοκρασία, υγρασία, φωτεινότητα",
        "temperature-text": "Θέλω ο κανόνας να εκτελείται εφόσον ένας αισθητήρας έχει μια τιμή.",
        "detect": "Ανίχνευση κίνησης",
        "detect-text": "Θέλω ο κανόνας να εκτελείται όταν ανιχνευθεί κίνηση.",
        "doorwindowsensor": "Άνοιγμα/Κλείσιμο παγίδας",
        "doorwindowsensor-text": "Θέλω ο κανόνας να εκτελείται εφόσον μια παγίδα είναι κλειστή ή ανοιχτή.",
        "choose-actions": "Επίλεξε ποιες ενέργειες θα εκτελούνται όταν τρέχει ο κανόνας:",
        "device": "Συσκευή",
        "change-settings": "θέλω να αλλάζουν οι ρυθμίσεις συσκεών π.χ να κλείνουν τα φώτα.",
        "scene": "Σενάριο",
        "activate-scene": "Θέλω να εκτελείται ένα έτοιμο σενάριο.",
        "notification": "Ειδοποίηση",
        "send-notification": "Θέλω να μου αποστέλλεται μια ειδοποίηση.",
        "select-notification": "Επιλογή ειδοποίησης",
        "choose-notification": "Επίλεξε τι είδους ειδοποίηση θέλεις να λαμβάνεις",
        "send-push": "Αποστολή push notification στο κινητό μου.",
        "email": "Email",
        "send-email": "Αποστολή email στην ηλεκτρονική μου διεύθυνση.",
        "select-scene": "Διάλεξε ποιο σενάριο θέλεις να εκτελείται με τον κανόνα.",
        "select-info": "Διάλεξε ποια συσκευή ή ομάδα θέλεις να συμμετέχει στον κανόνα.",
        "action": "Όρισε ποιά ενέργεια θέλεις να εκτελείται με τον κανόνα.",
        "select-device": "Επιλογή κατηγορίας συσκευής",
        "used": "Το σενάριο εκτελέστηκε επιτυχώς",
        "added": "Προστέθηκε στην Επισκόπηση",
        "send-option": "Αποστολή στην επισκόπηση",
        "deleted": "Ο κανόνας διαγράφηκε",
        "copy": "Δημιουργήθηκε αντίγραφο επιτυχώς",
        "created": "O κανόνας δημιουργήθηκε επιτυχώς",
        "trigger-deleted": "Το trigger διαγράφηκε",
        "condition-deleted": "Η συνθήκη διαγράφηκε",
        "action-deleted": "Η ενέργεια διαγράφηκε",
        "rule-error": "Δεν ήταν δυνατή η δημιουργία Κανόνα",
        "rule-activated": "Ο κανόνας ενεργοποιήθηκε",
        "rule-inactive": "Ο κανόνας απενεργοποιήθηκε",
        "updated": "Έγινε ενημέρωση του κανόνα επιτυχώς",
        "email-send": "Αποστολή email",
        "notification-send": "Αποστολή ειδοποίησεων",
        "email-notification-send": "Αποστολή email & ειδοποίησης"
    },

    "usersettings": {
        "actions": {
            "reject": "Απόρριψη",
            "accept": "Αποδοχή"
        }
    },

    "variables": {
        "status": "Κατάσταση",
        "temperature": "Θερμοκρασία",
        "humidity": "Υγρασία",
        "luminance": "Φωτεινότητα"
    },

    "AutoSavings": "Αυτόματη Εξοικονόμηση",
    "SmartTips": "Δράσεις Εξοικονόμησης",
    "SmartRecommendations": "Έξυπνες Συμβουλές",
    "ReceiveConsumptionStatistics": "Στατιστικά Κατανάλωσης",
    "NewsOffers": "Νέα & Προσφορές",
    "Thermostat": "Θερμοστάτης",
    "EnergyMeter": "Μετρητής Ενέργειας",
    "SmartPlug": "Έξυπνη Πρίζα",
    "Lamp": "Λάμπα",
    "DoorSensor": "Αισθητήρας Πόρτας",
    "AreaSensor": "Αισθητήρας Περιοχής",
    "household-info": "Στοιχεία Νοικοκυριού",
    "submit": "Υποβολή",
    "change-icon": "Αλλαγή εικονιδίου",
    "add-icon": "Πρόσθεσε εικονίδιο",
    "on": "Άνοιγμα",
    "off": "Κλείσιμο",
    "Cool": "Ψύξη",
    "Auto": "Αυτόματο",
    "Heat": "Θέρμανση",
    "Fanonly": "Ανεμιστήρας",
    "Dry": "Ξερός",
    "hot-water": "Zεστό νερό",
    "Devices": "Συσκευές"
}
